import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { printChecks } from '../../../redux/actions/CheckPrintingActions';
import { toastr } from 'react-redux-toastr';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import Select from '../../commonComponents/util/Select';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import SettingsMenu from '../SettingsMenu';
import PrintModal from '../../printingComponents/PrintModal';
import { formatCurrency, stripCurrencyFormat } from '../../../lib/utils';

class CheckPrintingPage extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = {
            fundId: '',
            quantity: '',
            presetAmount: '',
            date: '',
            showModals: {
                printModal: false
            }
        };
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    async printChecks(printerId) {
        await this.props.actions.printChecks('blankChecks',printerId, { fundId: this.state.fundId, amountOfBlankChecks: this.state.quantity, presetAmount: this.state.presetAmount, date: this.state.date });

        if (this.props.printing.success) {
            toastr.success('Printing completed.');
            this.setState({ fundId: '', quantity: '', presetAmount: '' });
        }
    }

    render() {
        const fund = this.state.fundId ? this.props.fundsWithLimits.find(f => f.key.toString() === this.state.fundId.toString()).value : {};
        return (
            <div className="page">
                <div className="subheader">
                    <div className="container flex-justify flex-center">
                        <SettingsMenu />
                    </div>
                </div>
                <div className="container">
                    <p className="section-header">Print Blank Checks</p>

                    <div className="flex">
                        <div className="column-third">
                            <label className="input-label">Fund</label>
                            <Select options={this.props.funds}
                                label="Fund"
                                name="fundId" value={this.state.fundId}
                                onChange={this.onChange.bind(this)} />
                        </div>

                        <div className="icon-right">
                            <label className="input-label">Quantity</label>
                            <input type="number" min="1" className="filled-input" name="quantity" value={this.state.quantity} onChange={this.onChange.bind(this)} />
                        </div>

                        <div className="icon-right">
                            <label className="input-label">Preset Amount</label>
                            <ValidatedInput input={<CurrencyFormatInput className="filled-input" />}
                                name="presetAmount"
                                value={this.state.presetAmount}
                                onChange={(name, val) => this.setState({ [name]: val })}
                                validated={true} showValidationError={true}
                                validate={val => !val || stripCurrencyFormat(val) <= fund.checkCuttingMax}
                                errorMessage={`Check amount cannot exceed ${formatCurrency(fund.checkCuttingMax)}.`} />
                        </div>

                        <div className="icon-right">
                            <label className="input-label">Date</label>
                            <input type="date" max="9999-12-31" value={this.state.date} name="date"  onChange={this.onChange.bind(this)} />
                        </div>
                    </div>

                    <button className="btn btn-primary" disabled={!this.state.fundId || !this.state.quantity || this.state.quantity < 1}
                        onClick={() => {
                            if (this.state.presetAmount <= fund.checkCuttingMax) this.toggleModal("printModal");
                        }}>Print</button>
                </div>

                {this.state.showModals.printModal &&
                    <PrintModal
                        close={this.toggleModal.bind(this, "printModal")}
                        onPrintSuccess={this.pushRoute.bind(this, '/print')}
                        count={this.state.quantity}
                        print={this.printChecks.bind(this)}
                    />}

            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        funds: state.funds.fundsByDept.US,
        printing: state.checkPrinting.printing,
        fundsWithLimits: state.funds.fundsByDept.allWithLimits
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ printChecks }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckPrintingPage);


// WEBPACK FOOTER //
// ./src/components/settingComponents/checkPrinting/CheckPrintingPage.jsx